<template>
  <div class="malicious-consumer-container">
    <!-- 页面标题与统计信息（删除返回按钮，修改标题和描述） -->
    <div class="page-header">
      <h2 class="page-title">恶意消费者</h2>
      <p class="page-desc">
        {{ cancelOver3Count }}名消费者24小时内取消订单达到3次
      </p>
    </div>
    <!-- 消费者表格（删除操作列） -->
    <div class="consumer-table">
      <el-table
        :data="maliciousList"
        style="width: 100%"
        border
        stripe
        v-loading="loading"
        element-loading-text="加载恶意消费者数据中..."
        empty-text="暂无24小时内取消订单达到3次的消费者"
      >
        <!-- openid列 -->
        <el-table-column
          prop="openid"
          label="消费者openid"
          width="400"
          align="center"
        />
        <!-- 注册手机号列（脱敏） -->
        <el-table-column
          prop="registeredMobile"
          label="注册手机号"
          width="300"
          align="center"
        >
          <template #default="{ row }">
            {{ formatPhone(row.registeredMobile) }}
          </template>
        </el-table-column>
        <!-- 微信名字列 -->
        <el-table-column
          prop="wechatName"
          label="微信名字"
          width="290"
          align="center"
        />
        <!-- 预警时间列（第3次取消时间） -->
        <el-table-column
          prop="warningTime"
          label="预警时间（第3次取消订单）"
          width="400"
          align="center"
        >
          <template #default="{ row }">
            {{ formatDateTime(row.warningTime) }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页器（保留原有逻辑） -->
    <div class="pagination">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 20, 50]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  name: "MaliciousConsumer",
  data() {
    return {
      loading: false, // 加载状态
      maliciousList: [], // 恶意消费者列表
      pagination: {
        // 分页配置
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      cancelOver3Count: 0, // 新增：24小时内取消3次订单的消费者总数
    };
  },
  mounted() {
    this.fetchMaliciousConsumers(); // 加载恶意消费者列表
    this.fetchCancelOver3Count(); // 新增：加载统计数据
  },
  methods: {
    // 获取恶意消费者列表（原有逻辑不变）
    async fetchMaliciousConsumers() {
      try {
        this.loading = true;
        const token = localStorage.getItem("token");
        if (!token) {
          this.$message.warning("请先登录");
          this.$router.push("/MerchantLogin");
          return;
        }
        const params = {
          page: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
        };
        const response = await this.$http.get(
          "/api/merchant/consumers/malicious",
          {
            params,
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data.code === 0) {
          const { list, pagination } = response.data.data;
          this.maliciousList = list.map((item) => ({
            ...item,
            registeredMobile: item.registeredMobile || "未设置",
            wechatName: item.wechatName || "未知用户",
            warningTime: item.thirdCancellationTime,
          }));
          this.pagination = pagination;
        } else {
          throw new Error(response.data.message || "获取恶意消费者列表失败");
        }
      } catch (error) {
        console.error("获取恶意消费者异常：", error);
        if (error.response?.status === 401) {
          this.$message.error("登录已过期，请重新登录");
          localStorage.removeItem("token");
          this.$router.push("/MerchantLogin");
        } else {
          this.$message.error(error.message || "数据加载失败，请稍后重试");
          this.maliciousList = [];
          this.pagination.total = 0;
        }
      } finally {
        this.loading = false;
      }
    },

    // 新增：获取24小时内取消3次订单的消费者总数
    async fetchCancelOver3Count() {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          this.$message.warning("请先登录");
          this.$router.push("/MerchantLogin");
          return;
        }
        // 调用后端统计接口（与ConsumerManage.vue复用同一接口）
        const response = await this.$http.get(
          "/api/merchant/consumers/cancel-over-3",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data.code === 0) {
          this.cancelOver3Count = response.data.data.count || 0;
        } else {
          throw new Error(response.data.message || "统计恶意消费者数量失败");
        }
      } catch (error) {
        console.error("统计恶意消费者数量异常：", error);
        if (error.response?.status === 401) {
          this.$message.error("登录已过期，请重新登录");
          localStorage.removeItem("token");
          this.$router.push("/MerchantLogin");
        } else {
          this.$message.error(error.message || "统计数据加载失败，默认显示0");
          this.cancelOver3Count = 0;
        }
      }
    },

    // 查看消费者详情（原有逻辑保留，虽无操作列，但可预留后续扩展）
    viewConsumerDetail(consumer) {
      this.$router.push({
        name: "ConsumerDetail",
        params: { consumerId: consumer._id },
      });
    },

    // 分页大小改变（原有逻辑不变）
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.pagination.currentPage = 1;
      this.fetchMaliciousConsumers();
    },

    // 当前页码改变（原有逻辑不变）
    handleCurrentChange(page) {
      this.pagination.currentPage = page;
      this.fetchMaliciousConsumers();
    },

    // 手机号脱敏（原有逻辑不变）
    formatPhone(phone) {
      if (!phone || phone.length !== 11) return phone;
      return phone.substring(0, 3) + "****" + phone.substring(7);
    },

    // 时间格式化（原有逻辑不变）
    formatDateTime(isoString) {
      if (!isoString) return "无";
      const date = new Date(isoString);
      const localTime = new Date(date.getTime() + 8 * 60 * 60 * 1000); // 转北京时间
      return localTime.toISOString().replace("T", " ").substring(0, 19);
    },
  },
};
</script>
<style scoped>
.malicious-consumer-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  min-height: calc(100vh - 64px);
}
.page-header {
  margin-bottom: 24px;
  border-bottom: 1px solid #f2f2f2;
  padding-bottom: 16px;
}
/* 删除返回按钮样式（因按钮已删除，对应样式可保留或删除，不影响） */
.back-btn {
  margin-bottom: 8px;
  display: inline-block;
}
.page-title {
  font-size: 18px;
  color: #333;
  margin: 0 0 8px 0;
}
.page-desc {
  font-size: 16px;
  color: #333;
  margin: 0;
}
.consumer-table {
  margin-bottom: 20px;
}
/* 已删除操作列样式 */
.action-buttons {
  display: flex;
  justify-content: space-around;
}
.pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
</style>